module.exports = __webpack_public_path__ + "static/media/__response.ad82864b.svg";